import mlPolicyCoverages from '../config/ml-available-policy-coverages.json'

const defaultConfig = {
    coverages: mlPolicyCoverages.coverages
};
const config = Object.assign({}, defaultConfig);

export default {
    getCoverage: (code) => {
        return config.coverages.find((item) => item.code === code);
    }
};